export const WASTE = {
  LEVEL: {
    MAJOR_CATEGORY: 'MAJOR_CATEGORY',
    MIDDLE_CATEGORY: 'MIDDLE_CATEGORY',
    MINOR_CATEGORY: 'MINOR_CATEGORY'
  },
  WASTE_REGULAR_TYPE: {
    BURNABLE_WASTE: '燃やすごみ',
    GLASS_BOTTLES: 'びん・缶・ペットボトル',
    OTHERS: 'その他',
    CARDBOARD: '段ボール'
  },
  WASTE_INDUSTRIAL_FREQUENCY: {
    WEEKLY: '毎週',
    MONTHLY: '毎月',
    SPOT: 'スポット'
  }
};
export const WasteTypeMap = {
  [WASTE.WASTE_REGULAR_TYPE.BURNABLE_WASTE]: 'BURNABLE_GARBAGE',
  [WASTE.WASTE_REGULAR_TYPE.GLASS_BOTTLES]: 'BOTTLES',
  [WASTE.WASTE_REGULAR_TYPE.OTHERS]: 'OTHERS',
  [WASTE.WASTE_REGULAR_TYPE.CARDBOARD]: 'CARDBOARD'
};
